import React, { useState, lazy, useEffect } from "react";
import Conversation from './conversation-module-new'
import ConversationOld from './conversation-module'
import {getParameterByName} from "../../utils/utils";
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
  const { messageSettingsOpen: {thirdChatAuth, comAuthInfo, messageOpenParams, companyNoExpire}, enterPriseInfo } = state
  return { thirdChatAuth, comAuthInfo, messageOpenParams, companyNoExpire, ...enterPriseInfo }
}
const IframeBridge = (props) => {
  const [showTrial, setShowTrial] = useState(false);
  const customerId = getParameterByName('customerId', true)
  const userId = getParameterByName('userId', true)
  const wxUserid = getParameterByName('wxUserid', true)
  const uids = getParameterByName('uids', true)
  // const customerId = '2063';
  // const userId = '6033666';
  // const wxUserid = 'wovPkPCQAAUgyb12yO-4saBEIoRQrw7g';
  useEffect(() => {
    if (props.companyNoExpire?.lastChatVersion == 2) {
      // 三方
      setShowTrial(true);
    } else if (props.companyNoExpire?.lastChatVersion == 1) {
      setShowTrial(false);
    }else if ( props.companyNoExpire?.onLyThird || (props.companyNoExpire?.isThrid && props.thirdChatAuth?.auth && !props.companyNoExpire.isBind)) {
      // 三方
      setShowTrial(true);
    }
  }, [props.thirdChatAuth, props.companyNoExpire])

  if (!(customerId && userId && wxUserid && uids)) {
    return null
  }
  const uidList = uids.split(',')
  return (

      showTrial ? <Conversation key={customerId} uid={userId} wxUserid={wxUserid} customerId={customerId} uidList={uidList} /> :
      <ConversationOld key={customerId} uid={userId} wxUserid={wxUserid} customerId={customerId} uidList={uidList} />

  )
}

export default connect(mapStateToProps, null)(IframeBridge)
